import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components'

export interface HeroExperimentImageProps {
  /**
   * Children to be rendered within this component.
   */
  children?: ReactNode
  /**
   * Background images
   */
  backgroundImage: string
  style: StyleProps
}

export interface StyleProps {
  minHeight: string
}

const StyledHeroExperimentImage = styled.div<HeroExperimentImageProps>`
  ${({ backgroundImage }) => {
    return css`
      background: lightgray 50% / cover no-repeat;
      background-image: url('${backgroundImage}');
      background-position: 50% 50%;
      background-repeat: no-repeat;
      background-size: cover;
      max-width: 80rem;
      margin: 0 auto;
      border-radius: 0 0 1rem 1rem;
    `
  }}
`

/**
 * Content wrapper component with flexible background images depending on screen size break-points.
 */
export const HeroExperimentImage: React.FC<HeroExperimentImageProps> = ({
  children,
  backgroundImage,
  ...rest
}) => {
  return (
    <StyledHeroExperimentImage
      backgroundImage={backgroundImage}
      role="banner"
      data-testid="hero-experiment-image"
      {...rest}
    >
      {children}
    </StyledHeroExperimentImage>
  )
}
